/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import React from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

interface TableCellLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  href: string;
  isFirstTableCell?: boolean;
  additionalStyles?: SerializedStyles;
}

export const TableCellLink = ({
  children,
  href,
  isFirstTableCell = false,
  additionalStyles,
  ...rest
}: TableCellLinkProps) => {
  const location = useLocation();
  const linkStyle = css`
    display: flex;
    padding: 12px;
    heigth: 100%;
    width: 100%;
    align-items: center;
    text-decoration: none !important;
    ${isFirstTableCell && "padding-left: 24px;"}
    ${additionalStyles}
  `;

  const tableCellStyle = css`
    padding: 0px !important;
  `;

  return (
    <td css={tableCellStyle}>
      <Link
        to={href}
        css={linkStyle}
        state={{
          from: `${location.pathname}${location.search ? location.search : ""}`,
        }}
        {...rest}
      >
        {children}
      </Link>
    </td>
  );
};
